
import React, { useState, useEffect } from "react";
export default function ChromeBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;

    // Detect Chrome on desktop (exclude Edge and Opera)
    const isChromeDesktop = /Chrome/.test(ua) && !/Edg|OPR/.test(ua);

    // Detect Chrome on iOS (CriOS)
    const isChromeiOS = /CriOS/.test(ua);

    const isChrome = isChromeDesktop || isChromeiOS;

    if (!isChrome) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 transition-transform duration-500 translate-y-0">
      <div className="bg-yellow-100 border-b border-yellow-300 text-yellow-900 px-4 py-2 text-center text-sm flex items-center justify-between">
        <span className="w-full text-center">
          🚨 For the best experience, please open this app in the <strong>Chrome</strong> browser on your iOS device.
        </span>
        <button
          onClick={() => setShow(false)}
          className="text-yellow-900 hover:text-yellow-600 px-2"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
